import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from '../../common/Component';
import classList from '../../common/utils/classList';
export let ColorScheme = /*#__PURE__*/function (ColorScheme) {
  ColorScheme["Auto"] = "auto";
  ColorScheme["Light"] = "light";
  ColorScheme["Dark"] = "dark";
  ColorScheme["LightHighContrast"] = "light-hc";
  ColorScheme["DarkHighContrast"] = "dark-hc";
  return ColorScheme;
}({});
export default class ThemeMode extends Component {
  view(vnode) {
    const {
      mode,
      selected,
      className,
      alternate,
      label,
      ...attrs
    } = vnode.attrs;
    return m("label", Object.assign({
      className: classList('ThemeMode', className, `ThemeMode--${mode}`, {
        'ThemeMode--active': selected,
        'ThemeMode--switch': alternate
      })
    }, attrs), m("div", {
      className: "ThemeMode-container",
      "data-theme": mode === 'auto' ? 'light' : mode,
      "data-colored-header": document.documentElement.getAttribute('data-colored-header')
    }, m("div", {
      className: "ThemeMode-preview"
    }, m("div", {
      className: "ThemeMode-header"
    }, m("div", {
      className: "ThemeMode-header-text"
    }), m("div", {
      className: "ThemeMode-header-icon"
    }), m("div", {
      className: "ThemeMode-header-icon"
    })), m("div", {
      className: "ThemeMode-hero"
    }, m("div", {
      className: "ThemeMode-hero-title"
    }), m("div", {
      className: "ThemeMode-hero-desc"
    })), m("div", {
      className: "ThemeMode-main"
    }, m("div", {
      className: "ThemeMode-sidebar"
    }, m("div", {
      className: "ThemeMode-startDiscussion"
    }, m("div", {
      className: "ThemeMode-startDiscussion-text"
    })), m("div", {
      className: "ThemeMode-items"
    }, Array.from({
      length: 3
    }).map((_, i) => m("div", {
      className: "ThemeMode-sidebar-line",
      key: i
    }, m("div", {
      className: "ThemeMode-sidebar-icon"
    }), m("div", {
      className: "ThemeMode-sidebar-text"
    }))))), m("div", {
      className: "ThemeMode-content"
    }, m("div", {
      className: "ThemeMode-toolbar"
    }, m("div", {
      className: "ThemeMode-button"
    }), m("div", {
      className: "ThemeMode-button"
    })), m("div", {
      className: "ThemeMode-items"
    }, Array.from({
      length: 3
    }).map((_, i) => m("div", {
      className: "ThemeMode-content-item",
      key: i
    }, m("div", {
      className: "ThemeMode-content-item-author"
    }), m("div", {
      className: "ThemeMode-content-item-meta"
    }, m("div", {
      className: "ThemeMode-content-item-title"
    }), m("div", {
      className: "ThemeMode-content-item-excerpt"
    })))))))), mode === 'auto' ? m(ThemeMode, Object.assign({
      mode: mode === 'auto' ? 'dark' : null,
      alternate: true,
      selected: selected
    }, attrs)) : null), !alternate ? m("div", {
      className: "ThemeMode-legend"
    }, label) : null);
  }
}
_defineProperty(ThemeMode, "colorSchemes", [{
  id: ColorScheme.Auto
}, {
  id: ColorScheme.Light
}, {
  id: ColorScheme.Dark
}, {
  id: ColorScheme.LightHighContrast
}, {
  id: ColorScheme.DarkHighContrast
}]);
flarum.reg.add('core', 'common/components/ThemeMode', ThemeMode);